// src/App.js
import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useMediaQuery } from './hooks/useMediaQuery';
import { AuthProvider, useAuth } from './hooks/useAuth';
import AIChat from './components/AIChat';
import VibeCoding from './components/VibeCoding';
import Navigation from './components/Navigation';
import ErrorBoundary from './components/ErrorBoundary';
import GoogleLoginButton from './components/GoogleLoginButton';
import ProfilePage from './components/ProfilePage';
import './components/ProfilePage.css';
import './App.css';

function AppContent() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [historyOpen, setHistoryOpen] = useState(false);
  const { isAuthenticated, isLoading, user } = useAuth();

  const handleToggleHistory = () => {
    console.log('App handleToggleHistory called, current state:', historyOpen);
    setHistoryOpen(!historyOpen);
  };

  if (isLoading) {
    return (
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'white' }}>
          Loading...
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="App">
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100vh', color: 'white', textAlign: 'center' }}>
          <h1 style={{ marginBottom: '2rem' }}>Welcome to BRIMIND AI Chat</h1>
          <p style={{ marginBottom: '2rem', opacity: 0.8 }}>Please login to access your AI assistant</p>
          <GoogleLoginButton />
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      <Router>
        <Navigation onShowHistory={handleToggleHistory} user={user} historyOpen={historyOpen} />
        <div className="app-content">
          <ErrorBoundary>
            <Routes>
              <Route path="/" element={
                <AIChat 
                  showHistory={historyOpen} 
                  onCloseHistory={handleToggleHistory} 
                />
              } />
              <Route path="/chat" element={
                <AIChat 
                  showHistory={historyOpen} 
                  onCloseHistory={handleToggleHistory} 
                />
              } />
              <Route path="/vibe-coding" element={
                <VibeCoding 
                  showHistory={historyOpen} 
                  onCloseHistory={handleToggleHistory} 
                />
              } />
              <Route path="/profile" element={<ProfilePage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </ErrorBoundary>
        </div>
      </Router>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;